import Formatter from 'src/class/Formatter';
import Tables from 'src/class/Tables';
import i18n from "src/i18n";

const configTable = () => {
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
          prop: 'date_save',
          label: i18n.t('common_words.date'),
          align: 'center',
          fixed: true,
          minWidth: 100,
        },
        {
          prop: 'farm',
          label: i18n.t('common_words.farm'),
          align: 'center',
          fixed: true,
          minWidth: 160,
        },
        {
          prop: 'supervisor',
          label: i18n.t('grow.supervisor'),
          align: 'center',
          fixed: true,
          minWidth: 150,
        },
        {
          prop: 'box',
          label: i18n.t('production.box'),
          align: 'center',
          minWidth: 200,
        },
        {
          prop: 'location',
          label: i18n.t('boxinspection.inspection_location_pcms'),
          align: 'center',
          minWidth: 160,
        },
        {
          prop: 'number_pallet',
          label: '# Pallet',
          align: 'center',
          minWidth: 90,
        },
        {
          prop: 'boxes_qty',
          label: i18n.t('production.boxes_quantity'),
          align: 'center',
          minWidth: 110,
          formatter: (row) => {
            return Formatter.formatNumber(row.boxes_qty);
          }
        },
        {
          prop: 'avg_weight',
          label: i18n.t('boxinspection.average_weight_pcms'),
          align: 'center',
          minWidth: 110,
          formatter: (row) => {
            return Formatter.formatNumber(row.avg_weight);
          },
        },
        {
          prop: 'avg_pcms',
          label: i18n.t('grow.quality_percentage'),
          align: 'center',
          minWidth: 100,
          formatter: (row) => {
            return Formatter.formatNumber(row.avg_pcms);
          },
        },
        {
          prop: 'defects_qty',
          label: i18n.t('boxinspection.number_defects'),
          align: 'center',
          minWidth: 120,
        },
    ];
    const Search = { ...Tables.Search };
    return { Table, Search };
};

export default configTable;